
export const MAX_AMOUNT_PERCENT = 100;
export const MAX_PRICE = 10000000;
export const MIN_AMOUNT = 0;
export const PERCENT_TYPE = 'Percentage';
